import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const buttonStyle = css`
  background-color: ${theme.colors.white};
  padding: ${theme.spacing(1)};
  box-shadow: ${theme.shadows.light};
  border-radius: ${theme.borderRadius.small};
`;
